
import ClientMonitor from './ClientMonitor';

if (!window.sys_monitor) {
    window.sys_monitor = new ClientMonitor();
}